import {DefaultShopClass} from "./DefaultShopClass";
import {utils} from "../utils";

/**
 *  Класс с методами, которые нужны на странице мероприятия и корзины
 * @extends DefaultShopClass
 */
export class EventShop extends DefaultShopClass {
	constructor() {
		super();
		this.$promo = null;
		this.isSectorPlan = false;
		this.$placesChange = null;
		this.$count = null;
		this.$svgElement = null;
		this.$currentCount = this.$count;
		this.$countWord = null;
		this.$prices = null;
		this.$sum = null;
		this.$tooltip = null;
		this.$planZoomIn = null;
		this.$planZoomOut = null;
		this.$planZoomReset = null;
		this.$botttom = null;
		this.$places = null;
		this.$placesLimit = null;
		this.storageArr = [];
		this.placesPrices = [];
		this.prices = null;
		this.uniquePrices = null;
		this.storageLimit = 10; //Лимит хранения мест и цен в минутах
		this.hasZoom = false;
	}

	initShop() {
		this.viewPromoButton();
	}

	viewPromoButton() {
		$.each(this.$promo, (index, element) => {
			const promoInput = $(element).find(".promo__input");
			promoInput.on("keypress", () => {
				$(element).addClass("active");
			});

			promoInput.on("input", () => {
				$(element).addClass("active");
			});

			promoInput.on("focus", () => {
				$(element).addClass("focus");
			});

			promoInput.on("blur", () => {
				$(element).removeClass("active").removeClass("focus");

				if (promoInput.val()) {
					$(element).addClass("active").removeClass("focus");
				}
			});
		});
	}

	setIsSectorPlan() {
		const sectors = this.$svg.find("g");
		$.each(sectors, (index, sector) => {
			if (Number($(sector).attr("mode")) === 1) {
				this.isSectorPlan = true;
			} else if (Number($(sector).attr("mode")) === 2) {
				this.isSectorPlan = false;
			}
		});
	}

	setTags() {
		$.each(this.$elements, (index, sector) => {
			$(sector).attr("view", $(sector).attr("view_id"));
			$(sector).attr("sector-name", $(sector).attr("view_id"));
			$(sector).attr("sector-id", $(sector).attr("view_id"));
			$(sector).attr("all", $(sector).attr("count"));
			$(sector).attr("data-type", "standart");
			if (!$(sector).attr("path")) {
				$(sector).attr("path", "right");
			}
		});
		if (!this.prices.length) {
			$.each(this.$elements, (index, sector) => {
				const price_min = $(sector).attr("price_min");
				const price_max = $(sector).attr("price_max");
				const priceInitial = $(sector).attr("price");
				const viewId = $(sector).attr("view_id");
				let price = [];

				if (priceInitial) {
					price = priceInitial;
				} else {
					if (price_min === price_max) {
						price = price_min;
					} else {
						price = price.concat(price_min, price_max);
						price = price.join();
					}
				}

				this.prices.push({price, viewId});
			});
		}
		this.uniquePrices = utils.uniqueArrayByProperty(this.prices, "price");
		const obj = {};
		for (let i = 0; i < this.uniquePrices.length; i++) {
			const price = this.uniquePrices[i].price;
			const viewId = this.uniquePrices[i].viewId;
			obj[viewId] = price;
		}
		this.uniquePrices = obj;
		for (let i = 0; i < this.prices.length; i++) {
			const item = this.prices[i];
			const viewId = item.viewId;
			const price = item.price;
			const element = $(`g[view_id='${viewId}']`);
			if (!element.attr("price")) {
				element.attr("price", price);
			} else {
				let strPrice = element.attr("price");
				element.attr("price", strPrice);
			}
		}
	}

	setZones(res) {
		this.$prices.html("");
		for (const prop in res.zones) {
			if (Object.prototype.hasOwnProperty.call(res.zones, prop)) {
				const zone = res.zones[prop];
				if (!zone || !zone.price || !zone.free) {
					continue;
				}
				const placesPrice = `<label class="places__price">
<input class="places__input" type="checkbox" data-price="${zone.price}" data-color="${zone.color}">
<span class="places__custom" style="background-color: ${zone.color}"></span>
<span class="places__price-content places__price-content_column">
${zone.price}  ₽, ${this.getWord("main", "left")} ${zone.free} ${utils.wordEnding(zone.free, [
					this.getWord("event", "seat"),
					this.getWord("event", "seats"),
					this.getWord("event", "seats "),
				])}</span>
</label>`;
				this.$prices.append(placesPrice);
			}
		}

		if (!this.isDesktop.matches) {
			this.$prices.append(
				$(`<div class="places__info-item places__info-item_sector places__info-item_disabled">
<div class="places__info-color"></div>
<div class="places__info-text">${this.getWord(
					"main",
					"sector is not available"
				)}</div></div>  <div class="places__info-item places__info-item_sector">
                        <button type="button" class="places__reset-prices reset-btn js-prices-reset"
                                style="display: none;">
                            <svg class="icon icon_close places__reset-icon">
                                <use xlink:href="#close"></use>
                            </svg>
                            <span class="places__reset-text">${this.getWord("main", "Reset")}</span>
                        </button>
                    </div>`)
			);
		}
		this.$prices.addClass("places__prices_sector");
		this.$prices.show();
		$(".places__price").hover(
			e => {
				const color = $(e.currentTarget).find(".places__custom").css("background-color");
				$(e.currentTarget).find(".places__price-content").css("border-color", color);
			},
			e => {
				const input = $(e.currentTarget).find("input");
				if (input.is(":checked")) {
					$(e.currentTarget)
						.find(".places__price-content")
						.css("border-color", input.data("color"));
				} else {
					$(e.currentTarget).find(".places__price-content").removeAttr("style");
				}
			}
		);
	}

	setPricesLabelToSector() {
		this.placesPrices = [];
		for (const prop in this.uniquePrices) {
			if (Object.prototype.hasOwnProperty.call(this.uniquePrices, prop)) {
				if (this.uniquePrices[prop] !== null) {
					const price = Number(this.uniquePrices[prop]);
					let sumFree = 0;
					let names = "";
					for (let i = 0; i < this.$elements.length; i++) {
						const element = $(this.$elements[i]);
						if (element.attr("price")) {
							const pricesAttr = element.attr("price").split(",");
							for (let j = 0; j < pricesAttr.length; j++) {
								if (price === Number(pricesAttr[j])) {
									const free = element.attr("free");
									const name = element.attr("sector-name");
									names += `${name}, `;
									sumFree += Number(free);
								}
							}
						}
					}
					names = names.substring(0, names.length - 1);
					names = names.substring(0, names.length - 1);
					if (sumFree && names) {
						this.placesPrices.push(`price:${price};free:${sumFree};names:${names}`);
					}
				}
			}
		}
		this.$prices.html("");
		this.placesPrices = Array.from(new Set(this.placesPrices));
		this.placesPrices = this.placesPrices.map(item => {
			return utils.convertStringToObject(item);
		});

		this.placesPrices = this.placesPrices.sort((a, b) => {
			return a.price - b.price;
		});
		for (let i = 0; i < this.placesPrices.length; i++) {
			const item = this.placesPrices[i];
			let names = item.names.split(",");
			names = Array.from(new Set(names));
			const placesPrice = `<label class="places__price">
<input class="places__input" type="checkbox" data-price="${item.price}">
<span class="places__custom"></span>
<span class="places__price-content places__price-content_column">
<strong>${item.price}  ₽, ${this.getWord("main", "left")} ${item.free} ${utils.wordEnding(
				item.free,
				[
					this.getWord("event", "seat"),
					this.getWord("event", "seats"),
					this.getWord("event", "seats "),
				]
			)}</strong></span>
</label>`;
			this.$prices.append(placesPrice);
		}
		this.$prices.addClass("places__prices_sector");
		this.$prices.show();
	}

	updatePlan() {
		const rect = this.$elements.find("rect");
		const ellipse = this.$elements.find("ellipse");
		const circle = this.$elements.find("circle");
		const polygon = this.$elements.find("polygon");
		const allTexts = this.$svgElement.find("text");
		const allTspan = this.$svgElement.find("tspan");

		function updateForm(element) {
			$.each(element, (index, elem) => {
				const form = $(elem);
				let text = form.find("text");
				if (!text.length) {
					text = form.nextAll("text");
				}
				form.css("stroke", "");
				rect.attr("rx", "2");
				text.css("font-weight", "500");
				text.css("font-family", "Roboto");
				text.css("fill", "#fff");

				let previousTransform = text.attr("transform");
				text.css("transform", "translateY(-1px)");

				if (previousTransform && previousTransform.includes("rotate")) {
					const index = previousTransform.indexOf(")");
					let sub = previousTransform.slice(0, index);
					sub = sub + "deg";
					previousTransform = sub + previousTransform.slice(index);
					text.removeAttr("transform");
					text.css("transform", `${previousTransform} translateY(-1px) translateX(1px)`);
				}
			});
		}

		updateForm(rect);
		updateForm(ellipse);
		updateForm(circle);
		updateForm(polygon);

		allTexts.css("font-weight", "500");
		allTexts.css("font-family", "Roboto");
		allTspan.css("font-weight", "");
	}

	setSvgPlan() {
		const $element = this.$placeToSvg.find("svg");
		const element = $element[0];
		const self = this;

		function setViewBox() {
			const width = $element.attr("width");
			const height = $element.attr("height");
			if (width && height) {
				$element.attr("viewBox", `0 0 ${width} ${height}`);
			}
		}

		setViewBox();
		var x = 0;
		var y = 0;
		let currentScale = 1;
		interact(element)
			.draggable({
				modifiers: [
					interact.modifiers.snap({
						targets: [interact.createSnapGrid({x: 10, y: 10})],
						range: Infinity,
						relativePoints: [{x: 0, y: 0}],
					}),
					interact.modifiers.restrict({
						restriction: element.parentNode,
						elementRect: {top: 0, left: 0, bottom: 1, right: 1},
						endOnly: true,
					}),
				],
				inertia: true,
			})
			.on("tap", event => {
				if (!this.isDesktop.matches) {
					/* Вышаем клик при нажати на иконку вида (для старых айфонов) */
					if ($(event.target).closest("image").length > 0)
						$(event.target).closest("image").trigger("click");

					$(event.target).parents("g").trigger("click");

					/*
					 * Есть баг на мобилке: при нажатии на сектор он добавляет билет и сразу же удаляет(двойной клик)
					 * Решение: добавил event.stopImmediatePropagation();
					 */
					event.stopImmediatePropagation();
				}
			})
			.on("dragmove", function (event) {
				x += event.dx;
				y += event.dy;

				event.target.style.transform =
					"translate(" + x + "px, " + y + "px)" + "scale(" + currentScale + ")";
				if (self.$stadiumPlace) {
					self.addStadium(); //update stadium place to position slider
				}
			});

		const checkZoom = () => {
			this.hasZoom = false;
			if (currentScale !== 1) {
				this.hasZoom = true;
			}
		};

		let timer = 0;

		$(document).on("click", this.$svg, () => {
			if (timer === 0) {
				timer = 1;
				timer = setTimeout(() => {
					timer = 0;
				}, 600);
			} else {
				this.$svg.addClass("active");
				timer = 0;
			}
		});

		$(document).on("touchstart", e => {
			const container = this.$svg;
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				this.$svg.removeClass("active");
			}
		});

		this.$planZoomIn.on("click", () => {
			currentScale += 0.2;
			element.style.transform =
				"translate(" + x + "px, " + y + "px)" + "scale(" + currentScale + ")";
			checkZoom();
		});

		this.$planZoomOut.on("click", () => {
			currentScale -= 0.2;
			if (currentScale <= 0.1) {
				currentScale = 0.1;
			}
			element.style.transform =
				"translate(" + x + "px, " + y + "px)" + "scale(" + currentScale + ")";
			checkZoom();
		});

		this.$planZoomReset.on("click", () => {
			x = 0;
			y = 0;
			currentScale = 1;
			element.removeAttribute("style");
			checkZoom();
		});
	}

	setColorToPlace(res) {
		this.placesPrices = [];
		$.each(res.prices, (index, element) => {
			const id = element.id;
			const zoneId = element.z;
			const name = this.createPlaceName(this.splitPlaceId(id));
			const zone = this.getZonePropertiesById(zoneId, res.zones);
			const price = zone.price;
			const color = zone.color;
			const selector = $(`#${id}`);
			selector.data("available", "true");
			selector.data("name", name);
			selector.data("zone", zoneId);
			selector.data("price", price);
			selector.data("color", color);
			this.placesPrices.push({price, color, zoneId});
			selector.removeClass("default").addClass("active");
			selector.find("rect").css("fill", color);
			selector.find("ellipse").css("fill", color);
			selector.find("circle").css("fill", color);
			selector.find("polygon").css("fill", color);
		});
	}

	/**
	 * Разбивает id места на массив значении
	 * @param {String} id - Строка в виде: s3r5p20
	 * @return {Array} - Возвращает массив в виде: [Место, Ряд, Сектор]
	 */
	splitPlaceId(id) {
		return id
			.split(/[^\d]/)
			.filter(element => element !== "")
			.reverse();
	}

	/**
	 * Создает название для места (например для тултипа)
	 * @param {Array} values - Массив значении в виде: [Место, Ряд, Сектор]
	 * @return {String} - Возвращает строку в виде: Ряд 3, место 21
	 */
	createPlaceName(values) {
		return `${this.getWord("main", "Row")} ${values[1]},
		 ${this.getWord("main", "place")} ${values[0]}`;
	}

	/**
	 * Возвращает значения зоны для получения цен и цвета
	 * @param {Number} zoneId - Номер зоны
	 * @param {Array} zones - Список зон
	 * @return {Object}
	 */
	getZonePropertiesById(zoneId, zones) {
		return zones.filter(element => element.zone === zoneId)[0];
	}

	addActionToPricesLabelToSector() {
		const that = this;

		function addAction(input) {
			if (input.is(":checked")) {
				input
					.parents(".places__price")
					.find(".places__price-content")
					.find(".places__price-content")
					.css("border-color", "#005aa5");
			} else {
				input.parents(".places__price").find(".places__price-content").removeAttr("style");
			}
			if ($(".places__price input:checked").length === 0) {
				$("g[view_id]").removeClass("inactive");
			} else {
				$("g[view_id]").each((i, elem) => {
					const el = $(elem);
					const myPriceStr = String(el.attr("price"));
					if (myPriceStr) {
						const myPrice = myPriceStr.split(",");
						let hideFlag = 0;

						for (let j = 0; j < myPrice.length; j++) {
							if (!$(`input[data-price="${parseInt(myPrice[j])}"]`).is(":checked")) {
								hideFlag++;
							}
						}
						if (hideFlag === myPrice.length) {
							el.addClass("inactive");
						} else {
							el.removeClass("inactive");
						}
					}
				});
			}

			if (that.$pricesReset) {
				if ($(".places__price input:checked").length > 1) {
					that.$pricesReset.show(200);
				} else {
					that.$pricesReset.hide(200);
				}
			}
		}

		$(".places__price input").change(e => {
			const input = $(e.currentTarget);
			addAction(input);
		});

		$(".places__price input").keypress(e => {
			if (e.which === 13) {
				const input = $(e.currentTarget);
				input[0].checked = !input[0].checked;
				addAction(input);
			}
		});
		if (this.$pricesReset) {
			this.$pricesReset.on("click", () => {
				$(".places__price input").removeClass("active");
				$("g[view_id]").removeClass("inactive");
				this.$pricesReset.hide(200);
				$(".places__price input").each((i, item) => {
					item.checked = false;
				});
				$(".places__price-content").removeAttr("style");
			});
		}
	}

	addActionToPricesLabelToPlace() {
		$(".places__price input").change(e => {
			const input = $(e.currentTarget);
			if (input.is(":checked")) {
				const color = input.data("color");
				input.next().css("border-color", color);
			}
			if ($(".places__price input:checked").length === 0) {
				$("g.active").removeClass("gray");
			} else {
				$("g.active").each((i, elem) => {
					const el = $(elem);
					const myPriceStr = String(el.data("zone"));
					if (myPriceStr) {
						const myPrice = myPriceStr.split(",");
						let hideFlag = 0;

						for (let j = 0; j < myPrice.length; j++) {
							if (!$(`input[data-zone="${parseInt(myPrice[j])}"]`).is(":checked")) {
								hideFlag++;
							}
						}
						if (hideFlag === myPrice.length) {
							el.addClass("gray");
						} else {
							el.removeClass("gray");
						}
					}
				});
			}
		});
		$(".places__price").hover(
			e => {
				const color = $(e.currentTarget)
					.find(".places__price-color")
					.css("background-color");
				$(e.currentTarget).find(".places__price-content").css("border-color", color);
			},
			e => {
				const input = $(e.currentTarget).find("input");
				if (input.is(":checked")) {
					$(e.currentTarget)
						.find(".places__price-content")
						.css("border-color", input.data("color"));
				} else {
					$(e.currentTarget).find(".places__price-content").removeAttr("style");
				}
			}
		);

		$(".places__price").on("click", e => {
			const element = $(e.currentTarget);
			if (element.find(".places__price-content").css("border-color") !== "transparent") {
				element.find(".places__price-content").css("border-color", "transparent");
			}

			if (!this.isDesktop.matches) {
				const input = element.find("input");
				if (input.is(":checked")) {
					input.removeAttr("checked");
				} else {
					input.attr("checked", "checked");
				}
				input.trigger("change");
			}
		});
	}

	setPricesLabelToPlace() {
		this.$prices.html("");
		this.placesPrices = utils.uniqueArrayByProperty(this.placesPrices, "color");
		this.placesPrices = this.placesPrices.sort((a, b) => {
			return a.price - b.price;
		});
		for (let i = 0; i < this.placesPrices.length; i++) {
			const item = this.placesPrices[i];
			const placesPrice = `<label   class="places__price">
<input class="places__input" type="checkbox" data-color="${item.color}" data-zone="${item.zoneId}">
<span class="places__price-content"><span class="places__price-color" style="background-color: ${item.color} "></span>
<span>${item.price}  ₽</span></span>
</label>`;
			this.$prices.append(placesPrice);
			this.$prices.removeClass("places__prices_sector");
		}
	}

	updateActiveSeat(sid, zoom) {
		const place = $(`#${sid}`);
		const rect = place.find("rect");
		const circle = place.find("circle");
		const ellipse = place.find("ellipse");

		function updateForm(form, zoom) {
			let bigZoom = 4;
			let smallZoom = 1;
			if (!zoom) {
				bigZoom = -4;
				smallZoom = -1;
			}

			function updateSize(size1, size2) {
				let currentSize = form.attr(size1);

				if (currentSize) {
					form.attr(size1, Number(currentSize) + bigZoom);
				} else {
					currentSize = form.attr(size2);
					form.attr(size2, Number(currentSize) + smallZoom);
				}
			}

			function updateCoord(coord1, coord2) {
				let currentCoord = form.attr(coord1);

				if (currentCoord) {
					form.attr(coord1, Number(currentCoord) - bigZoom / 2);
				} else {
					currentCoord = form.attr(coord2);
					form.attr(coord2, Number(currentCoord) - smallZoom);
				}
			}

			updateSize("width", "rx");
			updateSize("height", "ry");
			updateCoord("x", "cx");
			updateCoord("y", "cy");
		}

		updateForm(rect, zoom);
		updateForm(ellipse, zoom);
		updateForm(circle, zoom);

		if (zoom) {
			circle.attr("r", Number(circle.attr("r")) + 1);
		} else {
			circle.attr("r", Number(circle.attr("r")) - 1);
		}
	}

	setPlaceToStorage(sid, place) {
		const color = place.data("color");
		const name = place.data("name");
		const price = place.data("price");
		const storageObject = {sid, color, name, price};
		const getStorage = utils.getObjectFromSessionStorage(this.eventId);
		if (getStorage) {
			getStorage.push(storageObject);
			utils.setObjectToSessionStorage(this.eventId, getStorage);
		} else {
			this.storageArr.push(storageObject);
			utils.setObjectToSessionStorage(this.eventId, this.storageArr);
		}
	}

	updateCurrentEventSum(price, parent) {
		//если удаляем из корзины то обновить стоимость конкретного мероприятия
		const orderWrapper = $(parent).prev(".order__wrapper");
		const orderEventSum = $(orderWrapper).find(".js-order-event-sum");
		let oldSum = $(orderEventSum).text(); //стоимость
		if (oldSum && +oldSum >= 0) {
			$(orderEventSum).text(+oldSum - price);
		}
	}

	removeFromCart(sid, uid) {
		return this.handleRemoveFromCart(sid, uid).then(res => {
			if (res.error) {
				if (res.msg) alert(res.msg);
				window.location.reload();
			}
			if (res.redraw) {
				alert("Данное место больше недоступно. Выберите другое. ");
			}
			const carts = res.carts;
			let currentSumItem = null;
			let $currentDiscount = null;
			let currentCount = Number(this.$currentCount.text());
			currentCount -= 1;
			this.$currentCount.text(res.count);
			this.$countWord.text(
				utils.wordEnding(res.count, [
					this.getWord("event", "ticket"),
					this.getWord("event", "tickets"),
					this.getWord("event", "tickets "),
				])
			);
			this.updateActiveSeat(sid, false);

			if (carts.length >= 1) {
				for (let i = 0; i < carts.length; i++) {
					const currentSid = carts[i].sid;
					const currentUid = carts[i].uid;
					const ticketItem = $(`.tickets__item[data-uid='${currentUid}']`);
					const ticketItems = ticketItem.parents(".tickets__items");
					const currentOrderItem = ticketItem.parents(".js-order");
					currentSumItem = $(ticketItem).parents(".js-order").find(".js-sum");
					$currentDiscount = $(ticketItem)
						.parents(".js-order")
						.find(".js-promo-discount");
					ticketItem.remove();
					if (ticketItems.children().length === 0) {
						if ($(".lk").length && res.count === 0) currentOrderItem.remove();
						ticketItems.parents(".order__sub-event").remove();
					}
					$(`#${currentSid}`).removeClass("in-cart");
				}
			} else {
				const uid = carts[0].uid;
				$(`.tickets__item[data-uid='${uid}']`).remove();
				$(`#${sid}`).removeClass("in-cart");
			}

			if (this.isDesktop.matches) {
				this.setTransformForTickets();
			}
			if (currentSumItem && currentSumItem.length > 0) {
				//если удаляем из корзины то обновляем стоимость конкретного мероприятия
				$(currentSumItem).text(res.summ);
			} else {
				this.$sum.text(res.summ);
			}
			const currentEventId = this.eventId;
			if(res.active_carts[currentEventId] === undefined) {
				window.location.reload();
			}

			if (res.active_carts && res.active_carts[currentEventId] && this.$eventSum) {
				this.$eventSum.text(res.active_carts[currentEventId].summ);
			}
			//если удаляем из корзины то обновляем скидку по промокоду конкретного мероприятия
			$($currentDiscount).text(res.discount > 0 ? res.discount : 0);

			if ($(".lk").length && res.count === 0) {
				window.location.reload();
			}

			if (currentCount === 0) {
				$(".places__description").hide();
				$(".places__limit").hide();
				this.$placesChange.removeClass("short");
			}
			if (!$("#js-tickets-items").children().length > 0) {
				$("#js-order-info").hide();
				$(".places__cost").addClass("hide").removeClass("show");
				$(".modal-body .js-promo").hide();
				if (this.$placesLimit) {
					this.$placesLimit.hide();
				}
				if (this.$bottom) {
					this.$bottom.removeClass("active");
					this.$eventSum.text(0);
					this.actionAfterRemove();
				}
			}

			this.updateStorage(sid);
			this.getCartCount(this.eventId);
		});
	}

	actionAfterRemove() {
		$(".order__pull").removeClass("active");
		$("#js-places-change").removeClass("inactive");
		$(".order").removeClass("opened");
		$(".places__middle").removeClass("inactive");
		$(".js-tickets").removeClass("active");
		$(".modal_mobile-event .modal__content").removeClass("active");
	}

	updateStorage(sid) {
		const getStorage = utils.getObjectFromSessionStorage(this.eventId);
		for (let i = 0; i < getStorage.length; i++) {
			if (getStorage[i].sid === sid) {
				const place = $(`#${sid}`);
				const colorStorage = getStorage[i].color;
				const nameStorage = getStorage[i].name;
				const priceStorage = getStorage[i].price;
				const color = $(`.places__input[data-color="${colorStorage}"]`).data("color");
				place.data("name", nameStorage);
				place.data("price", priceStorage);
				place.removeClass("default");
				place.find("rect").css("fill", color);
				place.find("ellipse").css("fill", color);
				place.find("circle").css("fill", color);
				getStorage.splice(i, 1);
			}
		}
		utils.setObjectToSessionStorage(this.eventId, getStorage);
	}

	setPromocode(orderId, code, callback) {
		return this.handlePromocode(orderId, code).then(res => {
			const promo = $(`.js-promo[data-event=${this.eventId}]`);
			const parent = promo.closest(".js-order");

			if (res.status) {
				promo
					.find(".promo__button")
					.addClass("active")
					.text(this.getWord("main", "Applied"));
				promo.find(".promo__discount").addClass("active");
				promo.find(".promo__wrapper").css("pointer-events", "none");
				let sale = 0;
				let commission = 0;
				for (let i = 0; i < res.carts.length; i++) {
					sale += res.carts[i].discount;
					commission += res.carts[i].commission;
				}

				/* Вызываем обработчик после применения промокода */
				if (callback)
					try {
						callback({sale: sale});
					} catch (e) {}
				sale = Number(sale.toFixed(2));
				parent.find(".js-sum").html(res.summ);
				$.each(res.active_carts[this.eventId].carts, (i, ticket) => {
					$('.js-tickets-items')
						.find(`.tickets__item[data-uid=${ticket.uid}]`)
						.find(".js-ticket-price")
						.text(ticket.price);
				});

				parent.find(".js-promo-discount").html(sale);
				parent.find(".js-promo-commission").html(commission);
				promo.find(".promo__message").hide();
				promo.find(".promo__input").val(code).attr("disabled", true);
			} else {
				const message = res.msg;
				promo.find(".promo__message").addClass("error").text(message);
			}
			return res;
		});
	}

	setPayWithBonuses(orderId, bonuses) {
		return this.payWithBonuses(orderId, bonuses).then(response => {
			console.log(response);
			document.location.reload();
		});
	}

	addTooltip(activeSector, price, name, count = 0, free = 0) {
		const clientX =
			activeSector[0].getBoundingClientRect().x ||
			activeSector[0].getBoundingClientRect().left;
		const clientY =
			activeSector[0].getBoundingClientRect().y ||
			activeSector[0].getBoundingClientRect().top;
		let y = clientY - this.$tooltip.outerHeight();
		if (this.$tooltip.parents(".modal_subscription").length) {
			y -= this.$tooltip.parents(".modal_subscription")[0].getBoundingClientRect().top;
		}
		if ($(".modal_subscription").scrollTop() > 0) {
			y += $(".modal_subscription").scrollTop();
		}
		const x =
			clientX -
			this.$tooltip.outerWidth() / 2 +
			activeSector[0].getBoundingClientRect().width / 2;

		if (price !== undefined) {
			price = price.toString();
			price = price.split(",");
			price = price.sort((a, b) => {
				return a - b;
			});
			if (count) {
				price = Array.from(new Set(price));
				if (price.length > 1) {
					price = price.join(", ");
				}
			}
			price = `${this.getWord("event", "Price")} ${price}  ₽`;
			this.$tooltip.find(".tooltip-info__price").text(`${price}`);
		}

		this.$tooltip.find(".tooltip-info__name").text(`${name ? name : ""}`);
		this.$tooltip.find(".tooltip-info__available").text("");
		this.$tooltip.find(".tooltip-info__count").text("");
		if (free) {
			this.$tooltip
				.find(".tooltip-info__available")
				.text(`${this.getWord("main", "Free")} ${free}`);
		}
		if (count) {
			this.$tooltip
				.find(".tooltip-info__count")
				.text(`${this.getWord("main", "from")} ${count}`);
		}
		this.$tooltip.css({left: x, top: y});
		this.$tooltip.show();
	}

	setTransformForTickets() {
		const parent = $(".tickets_fixed");
		parent.addClass("active");
		const tickets = parent.find(".tickets__item");

		if (!tickets.length) {
			return false;
		}
		const length = tickets.length;

		let optimalWidth = parent.width() / length;
		let gap = 0;

		$.each(tickets, (i, item) => {
			const element = $(item);
			const elementWidth = element.width() + 2;
			gap = elementWidth - optimalWidth + element.width() / 2;
		});

		let width = parent.width() - gap;

		if (tickets.length <= 3) {
			return false;
		}

		let size = 0;
		optimalWidth = width / length;

		$.each(tickets, (i, item) => {
			const element = $(item);
			const elementWidth = element.width();
			gap = elementWidth - optimalWidth;
			let minus = "";
			if (size > 0) {
				minus = "-";
			}
			element.css("transform", `translateX(${minus}${size}px)`);
			size += gap;
		});
	}

	insertDataToTicket(item, isPack) {
		let sector = item.sector || item.view_id;
		const sid = item.sid || item.id;
		const currentEventId = item.event_id;

		if (!sector.includes("Сектор")) {
			sector = this.getWord("main", "Sector") + " " + sector;
		}

		const name = `${this.getWord("main", "Row")} ${item.row} ${this.getWord("main", "place")} ${
			item.col
		}`;

		let price;

		if (item.price) {
			price = item.price;
		} else {
			price = "";
		}

		return `<div class="tickets__item js-ticket-template" data-event="${currentEventId}" data-place="${sid}" data-uid="${item.uid}" data-ispack="${isPack}">
					<div class="tickets__content">
											<div class="tickets__sector">${sector}</div>

						<div class="tickets__place"><span class="js-ticket-place">${name}</span>
						<span class="tickets__place-price">
						<span class="js-ticket-price">${price}</span>
						 ₽</span>
					</div>
					<div class="tickets__remove js-tickets-remove">
						<button class="reset-btn tickets__remove-button"  type="button" data-selenium="event_seat_delete">Удалить</button>
					</div>
					</div>
					</div>`;
	}
}
